import React from 'react';
import { setCurrentView } from 'core/utils';
import { MarketplaceOrderDetailViewStore } from 'modules/order/stores';
import { MarketplaceOrderDetailTemplate } from 'themes/modules/order/pages';

@setCurrentView(rootStore => new MarketplaceOrderDetailViewStore(rootStore), 'marketplaceOrderDetailViewStore')
class MarketplaceOrderDetail extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <MarketplaceOrderDetailTemplate {...this.props} />;
	}
}

export default MarketplaceOrderDetail;
